export function stringAvatar(name: string | null) {
    if(!name) {
        return null;
    }
    const nameParts = name.split(' ');
    if(nameParts.length === 2) {
        return `${nameParts[1][0]}${nameParts[0][0]}`;
    }
    if(nameParts.length === 1) {
        return name[0];
    }
    return null;
}
